export const PRICING = {
	BUYER: {
		MANAGED: {
			ENTRY_PRICE: {
				oneMonth: 400,
				twelveMonth: 4000
			},
			REGULAR_PRICE: {
				oneMonth: 600,
				twelveMonth: 6000
			},
		}
	},
	SUPPLIER: {
		MANAGED: {
			REGULAR_PRICE: {
				oneMonth: 50,
				twelveMonth: 500
			},
		}
	}
}
